import moment from "moment";
import { useState } from "react";
import Box from "../../components/Box";
import MainLayout from "../../components/layouts/MainLayout";
import Pagination from "../../components/Pagination";
import AlertBox from "../../components/AlertBox";
import { useReportMigrationOLt } from "../../utils/customer/CustomerMigrationsUtil";

export default function ReportMigrationOltPage() {
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });

  const [formFilter, setFormFilter] = useState({ q: "" });
  const [filter, setFilter] = useState({ q: "", page: 1, page_size: 25 });

  const { customers, meta, loading, errorMsg } = useReportMigrationOLt({ filter });

  const applyFilter = () => {
    let form_filter = {
      ...filter,
      ...formFilter,
      page: 1,
    };
    setFilter(form_filter);
  };

  const resetFilter = () => {
    setFormFilter({ q: "" });
    setFilter({ q: "", page: 1, page_size: 25 });
  };

  const changeFilter = (name, value) => {
    setFormFilter({ ...formFilter, [name]: value });
  };

  const gotoPage = (page) => {
    setFilter({ ...filter, page: page });
  };

  return (
    <MainLayout resource_key="manage-customer">
      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col">
            <h1 className="h3 mb-0 text-gray-800">Laporan Migrasi OLT</h1>
          </div>
        </div>

        <Box title={`Laporan Migrasi OLT (Total Data: ${meta.count})`} loading={loading}>
          <div className="mb-4">
            <div className="row">
              <div className="col-12 col-md-2">
                <div className="form-group">
                  <label htmlFor="search">Pencarian</label>
                  <input
                    type="text"
                    value={formFilter.q}
                    placeholder="Cari berdasarkan nomor registrasi, nama pelanggan, atau lainnya..."
                    onChange={(event) => changeFilter("q", event.target.value)}
                    className="form-control"
                    id="search"
                  />
                </div>
              </div>
              <div className="col-auto">
                <button
                  className="btn btn-primary"
                  onClick={() => applyFilter()}
                  style={{ marginTop: "32px" }}
                >
                  Filter
                </button>
                <button
                  className="btn btn-default"
                  onClick={() => resetFilter()}
                  style={{ marginTop: "32px" }}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>

          {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}
          <AlertBox {...alert} setAlert={setAlert} />

          <div
            style={{
              overflowX: "auto",
            }}
          >
            <table className="table table-hover table-bordered table-striped">
              <thead>
                <tr>
                  <th>Nama Pelanggan</th>
                  <th>No. Registrasi</th>
                  <th>Asal OLT</th>
                  <th>OLT Migrasi</th>
                  <th>Tanggal Migrasi</th>
                </tr>
              </thead>
              <tbody>
                {customers.length === 0 && (
                  <tr>
                    <td colSpan={5} className="text-center">
                      Tidak ada data
                    </td>
                  </tr>
                )}
                {customers.map((migration, index) => (
                  <tr key={migration.id || index}>
                    <td>{migration.customer?.name || "-"}</td>
                    <td>{migration.customer?.registration_number || "-"}</td>
                    <td>{migration.from_olt?.name || "-"}</td>
                    <td>{migration.to_olt?.name || "-"}</td>
                    <td>
                      {migration.created_at
                        ? moment(migration.created_at).format("DD MMMM YYYY - HH:mm")
                        : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {meta.count > meta.page_size && (
            <Pagination
              totalpage={Math.ceil(meta.count / meta.page_size)}
              selectedpage={meta.page}
              clickpage={(page) => gotoPage(page)}
              next={() => gotoPage(meta.page + 1)}
              prev={() => gotoPage(meta.page - 1)}
            />
          )}
        </Box>
      </div>
    </MainLayout>
  );
}
